import ScheduleContainer from './ScheduleContainer';

export default ScheduleContainer;
